const API_BASE = import.meta.env.VITE_API_BASE_URL ?? '/api/v1';

export function apiUrl(path: string): string {
  return `${API_BASE}${path}`;
}

export class ApiError extends Error {
  constructor(
    message: string,
    readonly status: number,
    readonly code: string,
    readonly requestId?: string,
    readonly details?: unknown,
  ) {
    super(message);
  }
}

export async function api<T>(
  path: string,
  init: RequestInit & { json?: unknown } = {},
): Promise<T> {
  const headers = new Headers(init.headers);
  let body = init.body;
  if (init.json !== undefined) {
    headers.set('Content-Type', 'application/json');
    body = JSON.stringify(init.json);
  }
  const response = await fetch(`${API_BASE}${path}`, {
    ...init,
    headers,
    body,
    credentials: 'include',
  });
  if (!response.ok) {
    const payload = (await response.json().catch(() => null)) as {
      message?: string | string[];
      code?: string;
      requestId?: string;
      details?: unknown;
    } | null;
    const message = Array.isArray(payload?.message)
      ? payload.message.join('；')
      : payload?.message || `请求失败 (${response.status})`;
    throw new ApiError(
      message,
      response.status,
      payload?.code ?? 'REQUEST_FAILED',
      payload?.requestId,
      payload?.details,
    );
  }
  if (response.status === 204) {
    return undefined as T;
  }
  return response.json() as Promise<T>;
}

export function money(cents: number | null | undefined): string {
  return typeof cents === 'number'
    ? new Intl.NumberFormat('zh-CN', { style: 'currency', currency: 'CNY' }).format(cents / 100)
    : '—';
}

export function dateTime(value: string | null | undefined): string {
  return value ? new Date(value).toLocaleString('zh-CN', { hour12: false }) : '—';
}
